import React, { useEffect } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Button, Box, Typography } from '@mui/material';

const GoogleLoginButton = ({ onSuccess, onError }) => {
  const [available, setAvailable] = React.useState(false);
  // Test de connectivité simple
  const testAPI = async () => {
    try {
      const API_URL = process.env.REACT_APP_ESDRAS_API_URL;
      const response = await fetch(`${API_URL}/`, { method: 'GET' });
      console.log('API test response:', response.status, await response.text());
      setAvailable(response.ok);
    } catch (error) {
      console.error('API test failed:', error);
    }
  };

  // Appel du test au chargement (pour debug)
  React.useEffect(() => {
    testAPI();
  }, []);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      // Utiliser l'API Esdras depuis .env
      const API_URL = process.env.REACT_APP_ESDRAS_API_URL;
      
      // Envoyer le token Google à notre API pour validation et création/récupération user
      const uuid = localStorage.getItem('anonUserId');
      const query = new URLSearchParams(uuid ? { uuid } : {}).toString();
      
      const response = await fetch(`${API_URL}/auth/google?${query}`, {
        method: 'POST',
        mode: 'cors', // Explicite
        credentials: 'include', // Pour les cookies si nécessaire
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          credential: credentialResponse.credential,
        }),
      });

      if (response.ok) {
        const userData = await response.json();
        console.log('Google login success:', userData);
        onSuccess && onSuccess(userData);
      } else {
        const error = await response.json();
        console.error('Google login API error:', error);
        onError && onError(error);
      }
    } catch (error) {
      console.error('Google login error:', error);
      onError && onError(error);
    }
  };

  const handleGoogleError = (error) => {
    console.error('Google login failed:', error);
    
    // Messages d'erreur spécifiques
    if (error?.error === 'invalid_client') {
      console.error('❌ Client ID Google invalide. Vérifiez:');
      console.error('1. Client ID dans .env');
      console.error('2. Configuration dans Google Cloud Console');
      console.error('3. Domaines autorisés dans Google Console');
    }
    
    onError && onError(error);
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
      {available && (
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
          theme="outline"
          size="large"
          text="continue_with"
          locale="fr"
        />
      )}
    </Box>
  );
};

export default GoogleLoginButton;